import { ManufacturerRepository } from '../data/manufacturer-repository';
import { ManufacturerItem, UpdateManufacturerRequest } from '../types/manufacturer-types';

export class UpdateManufacturerUseCase {
  constructor(private readonly repository: ManufacturerRepository) {}

  async execute(id: number, data: UpdateManufacturerRequest): Promise<ManufacturerItem> {
    return this.repository.update(id, data);
  }
}
